import React from 'react';
import { compose } from 'react-recompose';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';

import Button from '../../../../components/Button';
import HasRole from '../../../../components/HasRole';
import { withEnabledFeatures } from '../../../../utils/features';

import * as constants from '../../../Authorization/constants';
import { BASIC_INFO_TAB_IDX, MEDIA_TAB_IDX, LINKS_AND_PROFILES_TAB_IDX, INTRO_TAB_IDX } from '../../constants';
import '../../styles.css';

export const messages = defineMessages({
  information: {
    id: 'college-profile.publish.information',
    defaultMessage: 'Publish my information changes',
  },
  intro: {
    id: 'college-profile.publish.intro',
    defaultMessage: 'Publish intro changes',
  },
  media: {
    id: 'college-profile.publish.media',
    defaultMessage: 'Publish my media changes',
  },
  linksAndProfiles: {
    id: 'college-profile.publish.linksAndProfiles',
    defaultMessage: 'Publish my links & spotlights changes',
  },
});

const tabIndexes = ['information', 'intro', 'media', 'linksAndProfiles'];

const isDisabled = (activeTabIndex, hasMediaChanges, hasLinksAndProfilesChanges, hasIntroChanges, hasBasicInfoChanges, hasInvalidLinks) => {
  if (hasMediaChanges && activeTabIndex === MEDIA_TAB_IDX) {
    return false;
  }
  if (hasLinksAndProfilesChanges && activeTabIndex === LINKS_AND_PROFILES_TAB_IDX) {
    if (!hasInvalidLinks) {
      return false;
    }
  }
  if (hasIntroChanges && activeTabIndex === INTRO_TAB_IDX) {
    return false;
  }
  if (hasBasicInfoChanges && activeTabIndex === BASIC_INFO_TAB_IDX) {
    return false;
  }
  return true;
};

export const PremiumPublishButtonComponent = ({
  onClick,
  activeTabIndex,
  hasMediaChanges,
  hasLinksAndProfilesChanges,
  hasIntroChanges,
  hasBasicInfoChanges,
  hasInvalidLinks,
  enabledFeatures,

}) => {
  const shouldShowButton = enabledFeatures?.includes(constants.REMOVE_COLLEGE_BASIC_INFO) ?
    activeTabIndex > 0 :
    true;
  return (
    <HasRole anyOf={[constants.ADMIN_ROLE, constants.PUBLISHING_ROLE]}>
      {shouldShowButton && (
        <div styleName="button-container">
          <Button
            secondary
            disabled={
              isDisabled(activeTabIndex, hasMediaChanges, hasLinksAndProfilesChanges, hasIntroChanges, hasBasicInfoChanges, hasInvalidLinks)
            }
            onClick={onClick}
          >
            {
              activeTabIndex >= 0 && <FormattedMessage {...messages[tabIndexes[activeTabIndex]]} />
            }
          </Button>
        </div>
      )}
    </HasRole>
  );
};

PremiumPublishButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  hasMediaChanges: PropTypes.bool,
  hasLinksAndProfilesChanges: PropTypes.bool,
  hasIntroChanges: PropTypes.bool,
  hasBasicInfoChanges: PropTypes.bool,
  hasInvalidLinks: PropTypes.bool,
  enabledFeatures: PropTypes.array,
};

const mapStateToProps = (state) => {
  const isRequestInformationLinkInvalid = get(state, 'nonPersistedCollegeProfile.linksAndProfiles.requestInformationLink.isUrlInvalid');
  const isApplyOnlineLinkInvalid = get(state, 'nonPersistedCollegeProfile.linksAndProfiles.applyOnlineLink.isUrlInvalid');
  const learnMoreLinks = get(state, 'nonPersistedCollegeProfile.linksAndProfiles.learnMoreLinks', []);
  const hasInvalidLinks = isRequestInformationLinkInvalid ||
    isApplyOnlineLinkInvalid ||
    learnMoreLinks.some((link) => link.isUrlInvalid);

  return {
    hasMediaChanges: get(state, 'nonPersistedCollegeProfile.media.hasRegisteredChanges'),
    hasLinksAndProfilesChanges: get(state, 'nonPersistedCollegeProfile.linksAndProfiles.hasRegisteredChanges'),
    hasIntroChanges: get(state, 'nonPersistedCollegeProfile.intro.hasRegisteredChanges'),
    hasBasicInfoChanges: get(state, 'basicInfo.hasRegisteredChanges'),
    hasInvalidLinks,
  };
};
export default compose(
  withEnabledFeatures,
  connect(mapStateToProps),
)(PremiumPublishButtonComponent);
